import React from "react";
import SliderCont from "./SliderCont";

export default function Programas() {


  return (
    <section className="section blackbg" id="programas">
      <h2 className="title"> PROGRAMAS</h2>
      {/* <p className="parrafo">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores hic
        voluptatem id quod aspernatur, qui maxime ipsa culpa, iure praesentium
        iusto laborum natus excepturi impedit aperiam sequi aut temporibus
        repellat?Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Reiciendis minima ipsam molestiae, voluptatem cum adipisci neque earum
        sapiente possimus libero. Facilis, iusto ad praesentium rerum voluptatem
        tenetur ut eius ipsa.
      </p> */}

   <SliderCont />


    </section>
  );
}
